<template>
    <div class="idp-register-form-root">
        <el-form
            ref="formIdp"
            :model="form"
            :rules="rules"
            class="form-idp-register form-idp-register--tight"
            hide-required-asterisk
            label-width="0"
            @submit.native.prevent="submit"
        >
            <!-- I. Thông tin đăng ký -->
            <section aria-labelledby="idp-section-register" class="idp-section">
                <h3 id="idp-section-register" class="idp-section__title">I. Thông tin đăng ký thi tại hội đồng</h3>
                <div class="grid-filter">
                    <el-form-item prop="user_id">
                        <div class="display-flex-column">
                            <span class="field-label">Học viên <span class="text-required">*</span></span>
                            <el-select
                                v-model="form.user_id"
                                :loading="search_loading"
                                :remote-method="remoteMethod"
                                class="w-100"
                                clearable
                                filterable
                                no-data-text="Không tìm thấy học viên"
                                no-match-text="Không có kết quả phù hợp"
                                placeholder="Mã học viên, tên hoặc SĐT"
                                remote
                                reserve-keyword
                            >
                                <el-option
                                    v-for="item in users"
                                    :key="item.id"
                                    :label="item.name + ' - ' + (item.id + 100000)"
                                    :value="item.id"
                                />
                            </el-select>
                        </div>
                    </el-form-item>

                    <el-form-item prop="exam_council_id">
                        <div class="display-flex-column">
                            <span class="field-label">Hội đồng thi <span class="text-required">*</span></span>
                            <el-select
                                v-model="form.exam_council_id"
                                class="w-100"
                                clearable
                                filterable
                                placeholder="Chọn hội đồng thi"
                            >
                                <el-option v-for="c in examCouncilOptions" :key="c.id" :label="c.label" :value="c.id"/>
                            </el-select>
                        </div>
                    </el-form-item>

                    <el-form-item class="grid-span-2" prop="address">
                        <div class="display-flex-column">
                            <span class="field-label">Địa chỉ <span class="text-required">*</span></span>
                            <el-input v-model="form.address" maxlength="500"
                                      placeholder="Địa chỉ liên hệ / thi của học viên" show-word-limit/>
                        </div>
                    </el-form-item>
                </div>
            </section>

            <!-- II. Thanh toán -->
            <section aria-labelledby="idp-section-payment" class="idp-section idp-section--payment">
                <h3 id="idp-section-payment" class="idp-section__title">II. Thông tin thanh toán</h3>
                <div class="grid-filter">
                    <el-form-item prop="payment_method">
                        <div class="display-flex-column">
                            <span class="field-label">Hình thức thanh toán <span class="text-required">*</span></span>
                            <el-select
                                v-model="form.payment_method"
                                class="w-100"
                                clearable
                                filterable
                                placeholder="Chọn hình thức"
                            >
                                <el-option label="Tiền mặt" value="cash"/>
                                <el-option label="Chuyển khoản" value="transfer"/>
                                <el-option label="Quẹt thẻ" value="card"/>
                            </el-select>
                        </div>
                    </el-form-item>

                    <el-form-item prop="payment_amount">
                        <div class="display-flex-column">
                            <span class="field-label">Số tiền cần thanh toán <span class="text-required">*</span></span>
                            <el-input
                                :value="formatVND(form.payment_amount)"
                                class="input-amount"
                                clearable
                                placeholder="Nhập số tiền"
                                @input="(v) => onAmountInput('payment_amount', v)"
                            >
                                <template slot="append">đ</template>
                            </el-input>
                        </div>
                    </el-form-item>

                    <el-form-item prop="idp_payment_amount">
                        <div class="display-flex-column">
                            <span class="field-label">Số tiền cần thanh toán cho IDP <span
                                class="text-required">*</span></span>
                            <el-input
                                :value="formatVND(form.idp_payment_amount)"
                                class="input-amount"
                                clearable
                                placeholder="Nhập số tiền"
                                @input="(v) => onAmountInput('idp_payment_amount', v)"
                            >
                                <template slot="append">đ</template>
                            </el-input>
                        </div>
                    </el-form-item>

                    <el-form-item prop="idp_transfer_area">
                        <div class="display-flex-column">
                            <span class="field-label">Khu vực chuyển khoản cho IDP <span class="text-required">*</span></span>
                            <el-select
                                v-model="form.idp_transfer_area"
                                class="w-100"
                                clearable
                                filterable
                                placeholder="Chọn khu vực"
                            >
                                <el-option v-for="a in transferAreaOptions" :key="a.id" :label="a.name" :value="a.id"/>
                            </el-select>
                        </div>
                    </el-form-item>

                    <el-form-item class="grid-span-2 idp-deadline-item" prop="idp_due_at">
                        <div class="display-flex-column idp-deadline-inner">
                            <span class="field-label">Thời hạn cần chuyển cho IDP <span
                                class="text-required">*</span></span>
                            <el-date-picker
                                v-model="form.idp_due_at"
                                align="right"
                                class="w-100 idp-date-picker"
                                clearable
                                format="dd/MM/yyyy"
                                placeholder="dd/mm/yyyy"
                                style="width: 100%; max-width: 320px"
                                type="date"
                                value-format="yyyy-MM-dd"
                            />
                            <p class="field-hint">Ngày cần hoàn tất chuyển khoản theo quy định trung tâm / hội đồng.</p>
                        </div>
                    </el-form-item>

                    <el-form-item class="grid-span-2" prop="note">
                        <div class="display-flex-column">
                            <span class="field-label field-label--optional">Ghi chú</span>
                            <el-input v-model="form.note" :rows="3" maxlength="1000"
                                      placeholder="Thông tin bổ sung (không bắt buộc)" show-word-limit
                                      type="textarea"/>
                        </div>
                    </el-form-item>
                </div>
            </section>

            <footer class="idp-form-footer">
                <el-button class="button-cancel" @click="$emit('close')">Hủy bỏ</el-button>
                <el-button
                    v-loading="saving"
                    :disabled="saving"
                    class="button-submit"
                    native-type="submit"
                    type="primary"
                >
                    Xác nhận
                </el-button>
            </footer>
        </el-form>
    </div>
</template>

<script>
import {SEARCH_CUSTOMER_BY_OR_ID} from "@/core/services/store/user/users.module";
import {CREATE_IDP_EXAM_REGISTER} from "@/core/services/store/idp-exam-register/idpExamRegister.module";

/** exam_council_id: 0 = IDP, 1 = BC (unsigned integer theo DB / JSON nghiệp vụ) */
const EXAM_COUNCIL_OPTIONS = Object.freeze([
    {id: 0, label: "IDP"},
    {id: 1, label: "BC"},
]);

export default {
    name: "FormIdpExamRegister",
    data() {
        return {
            saving: false,
            search_loading: false,
            users: [],
            examCouncilOptions: EXAM_COUNCIL_OPTIONS,
            transferAreaOptions: [],
            form: {
                user_id: null,
                exam_council_id: null,
                address: null,
                payment_amount: null,
                idp_payment_amount: null,
                idp_transfer_area: null,
                idp_due_at: null,
                note: null,
                payment_method: null,
            },
            rules: {
                user_id: [{required: true, message: "Vui lòng chọn học viên", trigger: "change"}],
                exam_council_id: [
                    {
                        validator: (_, v, cb) => {
                            if (v === null || v === undefined || v === "") {
                                return cb(new Error("Vui lòng chọn hội đồng thi"));
                            }
                            const n = Number(v);
                            if (n === 0 || n === 1) return cb();
                            return cb(new Error("Chỉ được chọn IDP hoặc BC"));
                        },
                        trigger: "change",
                    },
                ],
                address: [{required: true, message: "Vui lòng nhập địa chỉ", trigger: "blur"}],
                payment_method: [{required: true, message: "Vui lòng chọn hình thức thanh toán", trigger: "change"}],
                payment_amount: [
                    {
                        validator: (_, v, cb) => {
                            const n = Number(v);
                            if (!n || n < 0) return cb(new Error("Vui lòng nhập số tiền cần thanh toán"));
                            return cb();
                        },
                        trigger: "blur",
                    },
                ],
                idp_payment_amount: [
                    {
                        validator: (_, v, cb) => {
                            const n = Number(v);
                            if (!n || n < 0) return cb(new Error("Vui lòng nhập số tiền cần thanh toán cho IDP"));
                            return cb();
                        },
                        trigger: "blur",
                    },
                ],
                idp_transfer_area: [{
                    required: true,
                    message: "Vui lòng chọn khu vực chuyển khoản cho IDP",
                    trigger: "change"
                }],
                idp_due_at: [{required: true, message: "Vui lòng chọn thời hạn cần chuyển cho IDP", trigger: "change"}],
            },
        };
    },
    mounted() {
        this.transferAreaOptions = [
            {id: "HN_MIEN_BAC", name: "HN & Miền Bắc"},
            {id: "DN_HUE_QUANG_TRI", name: "Đà Nẵng, Huế, Quảng Trị"},
            {id: "HCM_MIEN_NAM", name: "HCM & Miền Nam"},
        ];
        this.$nextTick(() => {
            this.$refs.formIdp?.clearValidate();
        });
    },
    methods: {
        remoteMethod(query) {
            const q = (query || "").trim();
            if (!q) {
                this.users = [];
                this.search_loading = false;
                return;
            }
            this.search_loading = true;
            this.$store.dispatch(SEARCH_CUSTOMER_BY_OR_ID, {
                search_customer_by_phoneOrId: q,
                limit: 50,
                status: 1,
                is_staff: 0,
            }).then((res) => {
                this.users = res?.data?.data || res?.data || [];
            }).finally(() => {
                this.search_loading = false;
            });
        },
        formatVND(val) {
            if (val === null || val === undefined || val === "") return "";
            const n = Number(String(val).replace(/\D/g, ""));
            if (!n) return "";
            return n.toLocaleString("vi-VN");
        },
        onAmountInput(field, value) {
            const raw = String(value || "").replace(/\D/g, "");
            this.form[field] = raw ? Number(raw) : null;
        },
        submit() {
            this.$refs.formIdp.validate(async (valid) => {
                if (!valid) return;
                this.saving = true;
                try {
                    const council =
                        this.form.exam_council_id !== null &&
                        this.form.exam_council_id !== undefined &&
                        this.form.exam_council_id !== ""
                            ? Number(this.form.exam_council_id)
                            : null;
                    const payload = {
                        user_id: this.form.user_id,
                        exam_unit: council === 1 ? "BC" : "IDP",
                        address: this.form.address,
                        payment_method: this.form.payment_method,
                        payment_amount: this.form.payment_amount,
                        idp_payment_amount: this.form.idp_payment_amount,
                        idp_transfer_area: this.form.idp_transfer_area,
                        idp_due_at: this.form.idp_due_at,
                        note: this.form.note,
                    };
                    const res = await this.$store.dispatch(CREATE_IDP_EXAM_REGISTER, payload);
                    if (res?.error) {
                        this.$message.error(res?.message || "Tạo đăng ký thi thất bại");
                        return;
                    }
                    this.$message.success("Tạo đăng ký thi thành công");
                    this.$emit("created", {record: res?.data || res, payment_method: this.form.payment_method});
                    this.$emit("close");
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.log(e);
                    this.$message.error("Tạo đăng ký thi thất bại");
                } finally {
                    this.saving = false;
                }
            });
        },
    },
};
</script>

<style scoped>
.idp-register-form-root {
    color: #111827;
}

.text-required {
    color: #dc2626;
}

.field-label {
    display: block;
    margin: 0;
    padding: 0;
    font-size: 13px;
    font-weight: 600;
    color: #374151;
    line-height: 1.35;
}

.field-label--optional {
    font-weight: 500;
    color: #6b7280;
}

.field-hint {
    margin: 0;
    font-size: 12px;
    line-height: 1.45;
    color: #6b7280;
}

.field-hint--accent {
    color: #4b5563;
}

.idp-section {
    margin-bottom: 4px;
}

.idp-section--payment {
    margin-top: 8px;
    padding-top: 16px;
    border-top: 1px solid #e5e7eb;
}

.idp-section__title {
    margin: 0 0 14px;
    font-size: 13px;
    font-weight: 600;
    color: #1f2937;
    letter-spacing: 0.01em;
    padding-left: 10px;
    border-left: 3px solid #5e00b6;
    line-height: 1.3;
}

.display-flex-column {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    flex: 0 0 auto;
}

.grid-filter {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px 48px;
    align-items: start;
}

.grid-span-2 {
    grid-column: 1 / -1;
}

.idp-deadline-item >>> .el-form-item__content,
.idp-deadline-inner {
    max-width: 100%;
}

.idp-form-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    margin-top: 22px;
    padding-top: 16px;
    border-top: 1px solid #ebedf3;
}

.button-submit {
    background: #5e00b6 !important;
    border-color: #5e00b6 !important;
    color: #fff !important;
    padding-left: 18px !important;
    padding-right: 18px !important;
    border-radius: 4px !important;
    font-weight: 600;
}

.button-submit:hover,
.button-submit:focus {
    background: #4c0094 !important;
    border-color: #4c0094 !important;
}

.button-cancel {
    background: #cacaca;
    color: #111827;
    border-color: #cacaca;
}

.button-cancel:hover {
    color: #111827;
    background: #bdbdbd;
    border-color: #bdbdbd;
}

.form-idp-register >>> .el-form-item {
    margin-bottom: 0;
    width: 100%;
    align-self: start;
}

.form-idp-register >>> .el-form-item__content {
    line-height: normal;
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.form-idp-register >>> .el-form-item__content > .display-flex-column {
    flex: 0 0 auto;
    order: 1;
}

/* Element UI: .el-form-item__error mặc định position:absolute → đè lên label/hàng dưới */
.form-idp-register >>> .el-form-item__error {
    position: static !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    padding-top: 4px;
    line-height: 1.35;
    order: 2;
}

.form-idp-register >>> .input-amount .el-input-group__append {
    background: #f9fafb;
    color: #374151;
    font-weight: 600;
    min-width: 36px;
    text-align: center;
}

@media screen and (max-width: 576px) {
    .grid-filter {
        grid-template-columns: 1fr;
        gap: 14px;
    }
}
</style>

<style>
.form-idp-register--tight.el-form .el-form-item {
    margin-bottom: 0 !important;
}

.form-idp-register--tight.el-form .el-form-item__content {
    line-height: 1.25 !important;
    min-height: 0 !important;
}

.form-idp-register--tight.el-form .el-form-item__content .display-flex-column > .field-label {
    line-height: 1.35 !important;
}

.form-idp-register--tight.el-form .el-form-item__error {
    position: static !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    line-height: 1.35 !important;
    padding-top: 4px !important;
    margin-top: 0 !important;
}
</style>
